import axiosConfig from './axiosConfig';

const apiProjectKPI = {
   list: (filter) =>
      axiosConfig.requests.get(
         `/projectKPIs?PageNumber=${filter.pageNumber}&PageSize=${filter.pageSize}&BActive=${filter.bActive}&sDescription=${filter.sDescription}`
      ),
   /* Data Model */
   filterListDM: {
      pageNumber: 1,
      pageSize: 99999,
      sDescription: '',
      bActive: true,
   },
   details: (id) => axiosConfig.requests.get(`/projectKPIs/${id}`),
   create: (unit) => axiosConfig.requests.post('/projectKPIs', unit),
   update: (unit) => axiosConfig.requests.put(`/projectKPIs/${unit.id}`, unit),
   delete: (id) => axiosConfig.requests.del(`/projectKPIs/${id}`),
};

export default { apiProjectKPI };
